import Nullstack from 'nullstack';
export default function IconUserExclamation({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-user-exclamation",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "9",
    cy: "7",
    r: "4"
  }), "   ", Nullstack.element("path", {
    d: "M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"
  }), "   ", Nullstack.element("line", {
    x1: "19",
    y1: "7",
    x2: "19",
    y2: "10"
  }), "   ", Nullstack.element("line", {
    x1: "19",
    y1: "14",
    x2: "19",
    y2: "14.01"
  }), " ");
}